import axiosInstance from '@/plugins/axios';
import { RubricaAnaliseGraficosRequest } from '@/types/rubricas/analise/graficos/RubricaAnaliseGraficosRequest';
import { RubricaAnaliseGraficosResponse } from '@/types/rubricas/analise/graficos/RubricaAnaliseGraficosResponse';
import { RubricaAnaliseGraficosFiltrosResponse } from '@/types/rubricas/analise/graficos/RubricaAnaliseGraficosFiltrosResponse';

export default class ServiceRubricas {
  static consultarFiltros(signal = new AbortController().signal) {
    return axiosInstance.post<RubricaAnaliseGraficosFiltrosResponse>(
      'rubrica/analises/graficos/filtros/consultar',
      {},
      { signal },
    );
  }

  static consultarGraficos(
    body: RubricaAnaliseGraficosRequest,
    signal = new AbortController().signal,
  ) {
    return axiosInstance.post<RubricaAnaliseGraficosResponse>(
      'rubrica/analises/graficos/consultar',
      body,
      { signal },
    );
  }
}
